import api from '@pray/shared/utils/api';

import { ENTITY_TYPES } from './constants';

export const postComment = async ({ artistId, entityId, entityType, body } = {}) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!entityId) throw Error('Entity ID is required');
  if (!entityType) throw Error('Entity type is required');
  if (!body) throw Error('Comment body is required');

  const entityPath = entityType === ENTITY_TYPES.DAILY ? 'daily-items' : 'content';
  const url = `/web/studio/artists/${artistId}/${entityPath}/${entityId}/comments`;

  const response = await api.executePostRequest(url, { body });
  return response.data.data;
};
